import { useState, useContext } from "react";
import ImgPreview from "../components/global/imgPreview/imgPreview";
import BodyProject from "../components/project/BodyProject";
import HeaderProject from "../components/project/HeaderProject";
import NextProject from "../components/project/NextProject";
import { ProjectContext } from "../contexts/project";
import styles from "./project.module.css";

const Project = () => {
  const { projet: project, nextProject } = useContext(ProjectContext);
  const [image, setImage] = useState(null);
  return (
    <div className={styles.projectMain}>
      <HeaderProject project={project} setImage={setImage} />
      <BodyProject project={project} setImage={setImage} />
      <NextProject nextProject={nextProject} />
      <ImgPreview event={image} />
    </div>
  );
};

export default Project;
